module.exports = __webpack_public_path__ + "img/festival_cadeaukaart.9f2def96.svg";